import { useState, useEffect } from 'react';

export const useMobile = () => {
  const [isMobile, setMobile] = useState(
    window.innerWidth < 500 ? true : false
  );

  useEffect(() => {
    window.addEventListener('resize', () => checkMobile());

    return window.removeEventListener('resize', checkMobile);

    function checkMobile() {
      if (window.innerWidth < 500) {
        setMobile(true);
      } else if (window.innerWidth > 500) {
        setMobile(false);
      }
    }
  }, []);

  return isMobile;
};
